// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__39bQd","location":"Header_location__2_cWm"};